const mediaItems = [
  {
    title: '2026暑期档必看清单',
    desc: '盘点今年暑期最受期待的影视作品，从大片到小众佳作一网打尽。',
    tag: '编辑精选',
    views: '12.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20collage%20with%20warm%20golden%20sunset%20lighting%2C%20film%20posters%20in%20dark%20theater%20setting%2C%20vibrant%20coral%20and%20amber%20accents%2C%20professional%20entertainment%20visual%2C%20rich%20cinematic%20atmosphere%2C%20dramatic%20composition&width=800&height=500&seq=media-summer-2026&orientation=landscape',
  },
  {
    title: '国产悬疑剧崛起之路',
    desc: '从《隐秘的角落》到最新力作，国产悬疑剧的制作水准与叙事创新。',
    tag: '深度解析',
    views: '9.6万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20scene%20with%20dramatic%20lighting%2C%20film%20noir%20aesthetic%2C%20shadow%20play%20on%20urban%20street%2C%20warm%20amber%20highlights%2C%20suspenseful%20atmosphere%2C%20professional%20film%20photography%2C%20rich%20contrast&width=800&height=500&seq=media-mystery-drama&orientation=landscape',
  },
  {
    title: '经典电影修复计划启动',
    desc: '多部华语经典电影完成4K修复，以全新画质重温光影经典。',
    tag: '行业动态',
    views: '7.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20film%20restoration%20visual%20with%20old%20movie%20projector%20and%20film%20reels%2C%20warm%20sepia%20tones%2C%20classic%20cinema%20aesthetic%2C%20nostalgic%20atmosphere%2C%20dark%20rich%20background%2C%20golden%20accent%20lighting&width=800&height=500&seq=media-classic-restoration&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full border border-primary-500/20 mb-3">
            影视资讯
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            最新影讯 · 深度报道
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl mx-auto">
            影视行业前沿资讯与深度内容，让您了解幕后的精彩故事
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-medium bg-primary-500/90 text-background-50 rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-400 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>{item.views}
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-400 transition-colors duration-200">
                    <i className="ri-share-forward-line"></i>分享
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}